export enum DocumentType {
  Policy = 'policy',
  Document = 'document',
  Report = 'report',
};
